(function () {
  'use strict';

  // Action icons for the directory cards. Inline so they cost no requests
  // and inherit currentColor from the button state.
  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON_GLOBE = SVG_OPEN +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<line x1="2" y1="12" x2="22" y2="12"></line>' +
    '<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>';
  var ICON_PHONE = SVG_OPEN +
    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>';
  var ICON_PIN = SVG_OPEN +
    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>' +
    '<circle cx="12" cy="10" r="3"></circle></svg>';

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    var R = 3959; // miles
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function init() {
    var mapEl = document.getElementById('merchant-map');
    if (!mapEl || typeof L === 'undefined') return;

    var map = L.map('merchant-map', {
      scrollWheelZoom: false,
      gestureHandling: false
    }).setView([54.5, -2.5], 6);

    mapEl.addEventListener('click', function () {
      map.scrollWheelZoom.enable();
      mapEl.classList.add('map-active');
    });
    document.addEventListener('click', function (e) {
      if (!mapEl.contains(e.target)) {
        map.scrollWheelZoom.disable();
        mapEl.classList.remove('map-active');
      }
    });
    map.touchZoom.enable();
    map.dragging.enable();

    // Basemap: Esri dark grey canvas.
    //
    // This replaced CARTO's dark_all. CARTO now watermarks its free
    // basemaps — the tiles still return HTTP 200, but with "API KEY
    // REQUIRED" burned into the image, so nothing looked broken in the
    // network tab while the map read as unusable. Esri's canvas needs no
    // key and matches the dark UI closely.
    //
    // Esri splits this style into two layers: the base (landmass, roads)
    // and a separate reference layer carrying place labels. Both are
    // needed, with labels on top.
    var ESRI_CANVAS = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/';
    var esriAttribution = 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; ' +
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

    L.tileLayer(ESRI_CANVAS + 'World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
      attribution: esriAttribution,
      maxZoom: 16,
      updateWhenIdle: true,
      keepBuffer: 2
    }).addTo(map);

    // Labels go in their own pane between the tiles (200) and the markers
    // (600), so place names sit above the basemap without ever covering a
    // distributor pin.
    map.createPane('labels');
    map.getPane('labels').style.zIndex = 350;
    map.getPane('labels').style.pointerEvents = 'none';

    L.tileLayer(ESRI_CANVAS + 'World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 16,
      updateWhenIdle: true,
      keepBuffer: 2,
      pane: 'labels'
    }).addTo(map);

    var customIcon = L.divIcon({
      className: 'custom-leaflet-marker',
      html:
        '<div class="glowing-marker-wrapper">' +
          '<div class="glowing-marker-halo"></div>' +
          '<div class="glowing-marker">' +
            '<div class="glowing-marker-inner">' +
              '<span class="glowing-marker-label">BALLISTOL</span>' +
            '</div>' +
          '</div>' +
        '</div>',
      iconSize: [30, 40],
      iconAnchor: [15, 38],
      popupAnchor: [0, -35]
    });

    var allStores = [];
    var bounds = L.latLngBounds();
    var listContainer = document.getElementById('merchant-directory-list');
    var stockistCount = document.getElementById('stockistCount');

    function buildCard(store, searchLat, searchLng) {
      var card = document.createElement('div');
      card.className = 'directory-card';

      var distanceText = '';
      if (searchLat != null && searchLng != null) {
        var dist = getDistance(searchLat, searchLng, store.position.lat, store.position.lng);
        // Leads the address line after a search; the separator keeps the two
        // readable when they share a row.
        distanceText = '<span class="store-distance">' + dist.toFixed(1) + ' mi</span>' +
                       '<span class="store-sep"> &middot; </span>';
      }

      var logoHtml;
      if (store.logo) {
        logoHtml =
          '<img src="' + escapeHtml(store.logo) + '"' +
          ' alt="' + escapeHtml(store.title) + '"' +
          ' class="store-logo-img"' +
          ' loading="lazy"' +
          ' decoding="async"' +
          ' width="56" height="56"' +
          ' referrerpolicy="no-referrer"' +
          ' onerror="this.style.display=\'none\'">';
      } else {
        logoHtml =
          '<div class="store-placeholder-svg">' +
            '<svg width="32" height="32" viewBox="0 0 24 24" fill="#ff0000" aria-hidden="true">' +
              '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>' +
            '</svg>' +
          '</div>';
      }

      // Compact icon actions. Each is a real link so it keeps native
      // behaviour (open in tab, long-press, copy address); only the ones a
      // store actually has data for are rendered.
      var actions = '';
      if (store.website) {
        actions +=
          '<a class="store-action" href="' + escapeHtml(store.website) + '"' +
          ' target="_blank" rel="noopener noreferrer"' +
          ' title="Visit website" aria-label="Visit ' + escapeHtml(store.title) + ' website">' +
            ICON_GLOBE +
          '</a>';
      }
      if (store.phone) {
        actions +=
          '<a class="store-action" href="tel:' + escapeHtml(store.phone.replace(/[^\d+]/g, '')) + '"' +
          ' title="Call ' + escapeHtml(store.phone) + '"' +
          ' aria-label="Call ' + escapeHtml(store.title) + ' on ' + escapeHtml(store.phone) + '">' +
            ICON_PHONE +
          '</a>';
      }
      if (store.position) {
        actions +=
          '<a class="store-action" href="https://www.google.com/maps/dir/?api=1&destination=' +
          encodeURIComponent(store.position.lat + ',' + store.position.lng) + '"' +
          ' target="_blank" rel="noopener noreferrer"' +
          ' title="Directions" aria-label="Directions to ' + escapeHtml(store.title) + '">' +
            ICON_PIN +
          '</a>';
      }

      // Three columns: logo, text, actions. Keeping the buttons in their own
      // column rather than stacked under the text removes a whole row per
      // card, so noticeably more distributors fit without scrolling.
      card.innerHTML =
        '<div class="store-col store-col-image">' + logoHtml + '</div>' +
        '<div class="store-col store-col-info">' +
          '<h4>' + escapeHtml(store.title) + '</h4>' +
          '<p class="store-category">' + escapeHtml(store.category || '') + '</p>' +
          '<p class="store-address" title="' + escapeHtml(store.address || '') + '">' +
            distanceText + escapeHtml(store.address || '') + '</p>' +
        '</div>' +
        (actions ? '<div class="store-col store-actions">' + actions + '</div>' : '');

      // The whole card focuses the store on the map; the icon links keep
      // their own behaviour and must not trigger the fly-to.
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Show ' + store.title + ' on the map');

      function focusStore() {
        map.flyTo([store.position.lat, store.position.lng], 14, { duration: 1 });
        if (store._marker) store._marker.openPopup();
      }

      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        focusStore();
      });

      card.addEventListener('keydown', function (e) {
        if (e.target.closest('a')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          focusStore();
        }
      });

      return card;
    }

    function renderStores(stores, searchLat, searchLng) {
      while (listContainer.firstChild) listContainer.removeChild(listContainer.firstChild);
      if (stockistCount) stockistCount.textContent = stores.length + ' FOUND';

      var frag = document.createDocumentFragment();
      for (var i = 0; i < stores.length; i++) {
        frag.appendChild(buildCard(stores[i], searchLat, searchLng));
      }
      listContainer.appendChild(frag);
    }

    // Seed markers + list
    if (window.merchantStoresData && window.merchantStoresData.length > 0) {
      window.merchantStoresData.forEach(function (store) {
        var marker = L.marker([store.position.lat, store.position.lng], { icon: customIcon }).addTo(map);
        marker.bindPopup(
          "<div style='text-align:center;'>" +
            "<b>" + escapeHtml(store.title) + "</b><br>" +
            "<span style='font-size:11px;color:#666;'>" + escapeHtml(store.category || '') + "</span><br>" +
            "<span style='font-size:10px;'>" + escapeHtml(store.address || '') + "</span>" +
          "</div>"
        );
        store._marker = marker;
        bounds.extend([store.position.lat, store.position.lng]);
        allStores.push(store);
      });

      if (allStores.length > 0) map.fitBounds(bounds.pad(0.1));
      renderStores(allStores);
    }

    // Stop halo pulse after the initial attention window (saves GPU on idle)
    setTimeout(function () { mapEl.classList.add('halo-settled'); }, 4000);

    // Search
    var searchInput = document.getElementById('stockistSearchInput');
    var searchBtn = document.getElementById('stockistSearchBtn');
    var searchDebounce;
    var currentAbort;

    function textFilter(query) {
      var q = query.toLowerCase();
      return allStores.filter(function (s) {
        return (s.title || '').toLowerCase().indexOf(q) !== -1 ||
               (s.address && s.address.toLowerCase().indexOf(q) !== -1);
      });
    }

    function doSearch() {
      if (!searchInput) return;
      var query = searchInput.value.trim();
      if (!query) {
        renderStores(allStores);
        if (allStores.length > 0) map.fitBounds(bounds.pad(0.1));
        return;
      }

      if (currentAbort) currentAbort.abort();
      currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;

      var url = 'https://nominatim.openstreetmap.org/search?format=json&q=' +
                encodeURIComponent(query + ', UK') + '&limit=1';

      var fetchOpts = currentAbort ? { signal: currentAbort.signal } : undefined;

      fetch(url, fetchOpts)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.length > 0) {
            var lat = parseFloat(data[0].lat);
            var lng = parseFloat(data[0].lon);
            var sorted = allStores.slice().map(function (s) {
              s._distance = getDistance(lat, lng, s.position.lat, s.position.lng);
              return s;
            }).sort(function (a, b) { return a._distance - b._distance; });
            renderStores(sorted, lat, lng);
            map.setView([lat, lng], 10);
          } else {
            renderStores(textFilter(query));
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          renderStores(textFilter(query));
        });
    }

    if (searchBtn) searchBtn.addEventListener('click', doSearch);
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(doSearch, 350);
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(searchDebounce);
          doSearch();
        }
      });
    }
  }

  // Deferred script: DOM is parsed. Leaflet is loaded earlier in the defer queue.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
